import React, { useEffect, useState } from "react";
//import { useNavigate } from "react-router";
import CustomTable from "../../../components/CustomTable";
import { generateColumns,generateDataRows } from "./column";
import { getConsumableNewReport, getSales } from "../../../@app/subMaster/subMasterSlice";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Form, DatePicker, Card, Select } from "antd";
import { getAllMappedOutlet } from "../../../@app/subMaster/subMasterSlice";
import { useForm } from "react-hook-form";
import apis from "../../../api/entryApis";

export default function ConsumableEntryNewReport({ setTopTitle }) {
  setTopTitle("Consumable Report Details");
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Option } = Select;

  const { consumableData, salesData } = useSelector((state) => ({
    consumableData: state.subMaster.getConsumablenewReportResponse?.data || [],
    salesData: state.subMaster.getSalesResponse?.data || {},
  }));
  
  const rows = consumableData && salesData 
    ? generateDataRows(consumableData, salesData) 
    : [];
    
  // const handleEditClick = async (data) => {
  //   console.log(data,'data');
  //   try {
  //     const requestData = {
  //       startDate: startDate.toISOString().split("T")[0],
  //       endDate: endDate.toISOString().split("T")[0],
  //       outletid: selectedOutlets,
  //     }; 
  //     const response = await dispatch(
  //       getSales({
  //         path: "get-sales-rista",
  //         data: requestData,
  //       })
  //     );       
  //     navigate("/consumableEntryNewReport/addForm", {
  //       state: {
  //         ...data,
  //         outlet_id: data?.outlet_id,
  //         id: data?.id,
  //         salesData: response, // Pass the transformed sales data
  //       },
  //     });
  //   } catch (error) {
  //     console.error("Error fetching sales data:", error);
  //   }
  // };
  
  const { type, userData } = useSelector((state) => state.auth);

  useEffect(() => {
    if (type === 1)
      dispatch(
        getConsumableNewReport({ path: "get-Consumable-new-Report", data: {} })
      );
    else
      dispatch(
        getConsumableNewReport({
          path: "get-Consumable-new-Report",
          data: { employee: userData.data?.id }
        })
      );
  }, [dispatch, type, userData]);

  const {
    gettingConsumablenewReport,
    getConsumablenewReportResponse: { data: dataSource }
  } = useSelector((state) => state.subMaster);

  
  const columns = generateColumns(dataSource);

  const { handleSubmit } = useForm();

  const empId = userData.data?.id;
 
  const [selectedOutlets, setselectedOutlets] = useState([]);
  const [dropdownoutlet, setdropdownoutlet] = useState([]);
  const [startDate, setStartDate] = useState(null); // Declare startDate here
  const [endDate, setEndDate] = useState(null); // Declare endDate here

  const { gettingAllMappedOutlet } = useSelector((state) => state.subMaster);

  useEffect(() => {
    dispatch(getSales());
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result;
        if (type == 1) {
          result = await dispatch(
            getAllMappedOutlet({
              path: "get-all-mapped-outlet",
              data: {}
            })
          );
        } else {
          result = await dispatch(
            getAllMappedOutlet({
              path: "get-all-mapped-outlet",
              data: {
                employee: empId
              }
            })
          );
        }
        if (result) {
          const options = result.data.map((item) => ({
            key: item.outlet_code,
            value: item.outlet_code,
            label: `${item.outlet_code}-${item.name}`
          }));

          // Add "Select All" and "Unselect All" options
          options.unshift({
            key: "select_all",
            value: "select_all",
            label: "Select All"
          });
          options.unshift({
            key: "unselect_all",
            value: "unselect_all",
            label: "Unselect All"
          });

          setdropdownoutlet(options);
        }
      } catch (error) {
        // Handle errors if necessary
      }
    };

    fetchData();
  }, [type, empId, dispatch]);

  const SelectAllOutlets = () => {
    if (!dropdownoutlet || dropdownoutlet.length === 0) {    
      setselectedOutlets([]);
    } else {   
      const allValuesExceptSpecial = dropdownoutlet
        .filter(
          (option) =>
            option.value !== "select_all" && option.value !== "unselect_all"
        )
        .map((option) => option.value);
      setselectedOutlets(allValuesExceptSpecial);
    }
  };


  const handleFormSubmit = () => {
    if (!startDate || !endDate) {
      apis.open({ message: "Please select both Start Date and End Date", type: "error" });
      return;
    }

    // Format dates as YYYY-MM-DD
    const startSelectedDate = startDate.toISOString().split("T")[0];
    const endSelectedDate = endDate.toISOString().split("T")[0];

    if (new Date(startSelectedDate) > new Date(endSelectedDate)) {
      apis.open({ message: "Invalid date range", type: "error" });
      return;
    }

    const requestData = {
      startDate: startSelectedDate,
      endDate: endSelectedDate,
      outletid: selectedOutlets,
    };

    // Dispatch the `getSales` API
    dispatch(
      getSales({
        path: "get-sales-rista",
        data: requestData,
      })
    );

    // Dispatch the `getConsumableNewReport` API
    const reportData = {
      path: "get-Consumable-new-Report",
      data: requestData,
    };

    if (type === 1) {
      dispatch(getConsumableNewReport(reportData));
    } else {
      dispatch(
        getConsumableNewReport({
          ...reportData,
          data: {
            ...reportData.data,
            employee: empId,
          },
        })
      );
    }

    handleSubmit(); // Handle additional form submission logic
  };


  useEffect(() => {
    // Initial API call for Sales data
    dispatch(getSales());
  }, [dispatch]);

  // Add serial number to rows
  // const rowsWithSerialNumbers = dataSource ? dataSource.map((row, index) => ({
  //   ...row,
  //   "S.No": index + 1
  // })) : [];

  return (
    <>  
      <Card>     
        <Row style={{ margin: "3px" }} gutter={[9, 0]}>       
          <Col md={{ span: 7 }} xs={{ span: 24 }}>
            <Form.Item name="month" label="Date Filter">
              <DatePicker.RangePicker
                format="DD-MM-YYYY"
                onChange={(dates) => {
                  setStartDate(dates?.[0]);
                  setEndDate(dates?.[1]);
                }}
                value={[startDate, endDate]}
                dateFormat="MMMM d, yyyy"
              />
            </Form.Item>
          </Col>
          <Col md={{ span: 7 }} xs={{ span: 22 }}>
            <Form.Item label="Outlet Code">
              <Select
                placeholder="Select"
                name="status"
                loading={gettingAllMappedOutlet}
                maxTagCount={0}
                label="Waiting At"
                disabled={false}
                showSearch
                mode="multiple"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={selectedOutlets}
                onChange={(newSelectedValues) => {
                  // Handle "Select All" and "Unselect All"
                  if (newSelectedValues.includes("select_all")) {
                    SelectAllOutlets();
                  } else if (newSelectedValues.includes("unselect_all")) {
                    setselectedOutlets([]);
                  } else {
                    setselectedOutlets(newSelectedValues);
                  }
                }}
              >
                {dropdownoutlet.map((item) => (
                  <Option key={item.key} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col md={{ span: 4 }} xs={{ span: 24 }}>
            <Form.Item name="submit">
              <button
                onClick={handleFormSubmit}
                style={{
                  background: "#34b1aa",
                  color: "#ffffff",
                  margin: "15px"
                }}
                className="btn btn col-lg-2 col-m-2 col-sm-2 h-100 w-auto align-items-center"
              >
                Filter
              </button>
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <CustomTable
        loading={gettingConsumablenewReport}
        // dataSource={rowsWithSerialNumbers}
        dataSource={rows}
        column={columns}
        hideActionBtn={true}
        title={"Consumable Report Details"}
      />
    </>
  );
}
